import { render, staticRenderFns } from "./newDialog.vue?vue&type=template&id=75c206c9&scoped=true"
import script from "./newDialog.vue?vue&type=script&lang=js"
export * from "./newDialog.vue?vue&type=script&lang=js"
import style0 from "./newDialog.vue?vue&type=style&index=0&id=75c206c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c206c9",
  null
  
)

export default component.exports